module.exports = __webpack_public_path__ + "img/clear_filters.26db040e.svg";